export const FETCH = 'favorites/FETCH';
export const FETCH_SUCCESS = 'favorites/FETCH_SUCCESS';
export const FETCH_ERROR = 'favorites/FETCH_ERROR';

export const ADD_FAVORITE = 'favorites/ADD_FAVORITE';
export const ADD_FAVORITE_SUCCESS = 'favorites/ADD_FAVORITE_SUCCESS';
export const ADD_FAVORITE_ERROR = 'favorites/ADD_FAVORITE_ERROR';

export const REMOVE_FAVORITE = 'favorites/REMOVE_FAVORITE';
export const REMOVE_FAVORITE_SUCCESS = 'favorites/REMOVE_FAVORITE_SUCCESS';
export const REMOVE_FAVORITE_ERROR = 'favorites/REMOVE_FAVORITE_ERROR';
